// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./Section.scss";
import Button from "../Button";
import SectionTitle from "./SectionTitle";

type SectionProps = {
  children: React.Node,
  numbered?: boolean,
  numberedWithDot?: boolean,
  expandable?: boolean,
  reducedMargin?: boolean,
  noBottomMargin?: boolean,
  title?: string
};

const Section = ({
  title,
  reducedMargin,
  noBottomMargin,
  children,
  expandable,
  numbered,
  numberedWithDot
}: SectionProps) => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <div
      className={cx(
        { [styles.reducedMargin]: reducedMargin },
        { [styles.noBottomMargin]: noBottomMargin },
        styles.section
      )}
      data-testid="section"
    >
      {title && expandable ? (
        <Button theme="clean" onClick={() => setExpanded(!expanded)} withMargin>
          <SectionTitle expansionState={expanded ? "expanded" : "collapsed"} isExpandable>
            {title}
          </SectionTitle>
        </Button>
      ) : (
        title && (
          <SectionTitle numbered={numbered} numberedWithDot={numberedWithDot}>
            {title}
          </SectionTitle>
        )
      )}
      {(!expandable || (expandable && expanded)) && children}
    </div>
  );
};

Section.defaultProps = {
  numbered: false,
  expandable: false,
  reducedMargin: false,
  noBottomMargin: false,
  numberedWithDot: false,
  title: ""
};

export default Section;
